import * as React from 'react';
import { IconMapHighway16 } from '@cian/ui-kit-design-tokens/icons';
import { UIText2 } from '@cian/ui-kit/typography';

import { Link } from '../Link';
import * as styles from './VillageItem.css';
import { IVillage } from '../Villages';

interface IVillageItemProps {
  village: IVillage;
}

export const VillageItem: React.FC<IVillageItemProps> = ({ village }) => {
  return (
    <Link href={village.url} className={styles['link']}>
      <div className={styles['info']}>
        <UIText2 fontWeight="bold">{village.name}</UIText2>
        <div className={styles['price']}>
          <UIText2>от {village.priceDisplay} ₽</UIText2>
        </div>
        <div className={styles['location-container']}>
          <div className={styles['highway-icon']}>
            <IconMapHighway16 />
          </div>
          <span className={styles['location']}>{village.location}</span>
        </div>
      </div>
      <div className={styles['photo-wrap']} style={{ backgroundImage: `url(${village.imageUrl})` }} />
    </Link>
  );
};
